








import {
  LayoutConfig,
  LayoutDataSet,
} from '@/uikit/components/AppDefaultLayout/types/LayoutTypes';

export default {
  name: 'NavHeader',
  props: {
    cfg: {
      type: [
        Object as () => LayoutConfig['header']['sections']['navHeader'],
        Array,
      ],
      required: true,
    },
    data: {
      type: Array as () => LayoutDataSet['navSidebar'],
    },
  },
  methods: {
    clickElement(route: any) {
      this.$router.push(route);
    },
  },
  computed: {
    getSortedDate() {
      return [...this.data].sort((a: any, b: any) => {
        return a.orderNumber - b.orderNumber;
      });
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppDefaultLayout/components/sections/navHeader/NavHeader.vue